import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-publicidadck',
  templateUrl: './publicidadck.component.html',
  styleUrls: ['./publicidadck.component.scss']
})
export class PublicidadckComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
